import React, { useState } from "react";
import { toast } from "sonner";
import { UserX } from "lucide-react";
import api, { apiErrorMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export function BelumMengisiButton({ periode }) {
  const [open, setOpen] = useState(false);
  const [list, setList] = useState(null);

  const show = () => {
    setOpen(true);
    setList(null);
    api.get(`/admin/periode/${periode.id}/belum-mengisi`).then((r) => setList(r.data)).catch((e) => { toast.error(apiErrorMsg(e)); setOpen(false); });
  };

  return (
    <>
      <button onClick={show} disabled={periode.belum === 0} data-testid={`belum-mengisi-btn-${periode.id}`}
        className="px-2.5 py-1 border border-slate-300 hover:border-brass-500 disabled:opacity-40 disabled:hover:border-slate-300 rounded-sm text-xs font-semibold flex items-center gap-1.5 transition-colors">
        <UserX className="w-3.5 h-3.5" /> Lihat
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="belum-mengisi-dialog" className="w-[calc(100%-2rem)] rounded-sm">
          <DialogHeader>
            <DialogTitle>Serdik Belum Mengisi</DialogTitle>
            <DialogDescription>{periode.nama_periode || `${periode.jenis === "mingguan" ? "Minggu" : "Bulan"} ke-${periode.nomor}`} · {periode.kelompok_nama || "Tanpa kelompok"}</DialogDescription>
          </DialogHeader>
          {!list ? <div className="text-sm text-slate-500">Memuat...</div> : list.length === 0 ? (
            <div className="text-sm text-slate-500" data-testid="belum-mengisi-empty">Semua Serdik sudah mengisi.</div>
          ) : (
            <ol className="max-h-80 overflow-y-auto divide-y divide-slate-100 text-sm" data-testid="belum-mengisi-list">
              {list.map((s, i) => (
                <li key={s.id} className="py-2 flex gap-3" data-testid={`belum-mengisi-item-${s.id}`}>
                  <span className="font-mono text-slate-400 w-6">{i + 1}.</span>
                  <span className="flex-1 font-semibold text-navy-900">{s.nama}</span>
                  <span className="font-mono text-slate-500">{s.nosis}</span>
                </li>
              ))}
            </ol>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
